import React from 'react'

import { Container } from './styles'

const Logged: React.FC = ({ children }) => {
  return <Container>{children}</Container>
}

export default Logged
